module.exports = __webpack_public_path__ + "assets/img/Gather1.b004fbaa.jpg";